import { toBase64 } from "../../functions/base64";
import { useParams, useNavigate } from "react-router-dom";
import '../../styles/ProjectList.css';
import {useProjectsContext} from "../../context/ProjectsContext";
import z from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import ProjectHeader from "../../components/common/ProjectHeader/ProjectHeader";
import Flower from "../../components/common/Flower/Flower";
import ClickFlower from "../../components/common/ClickFlower/ClickFlower";
import { Link } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";


export default function CreateProject() {
    const navigate = useNavigate();
    const {setProjects} = useProjectsContext();

const schema = z.object({
 finishDate: z
  .string()
  .refine((val) => !isNaN(Date.parse(val)),
  "Nieprawidłowa data")
  .refine((val) => val > new Date().toISOString().split("T")[0],
  "Musisz wybrać datę z przyszłości"),
})

const {
  register,
  handleSubmit,
  formState: { errors }, trigger } = useForm({
  resolver: zodResolver(schema),
});

const CreateProject= async (e)=>{
    e.preventDefault();
    let ProjectTitle = e.target.title.value;
    let ProjectDescription = e.target.description.value;
    let ProjectMaxWords = e.target.words.value;
    let FinishDate = e.target.finishDate.value;
    let Cover = e.target.cover.files[0];

    if (Cover) {
      Cover = await toBase64(Cover)
    }
    
    const NewProject = {
      title: ProjectTitle,
      description: ProjectDescription,
      words: ProjectMaxWords,
      actualwords: 0,
      finishDate: FinishDate,
      cover: Cover,
      history: [],  
      settings: {
        chaptersEnabled: false,
        MinimumWordsInChapter: 1000,
        goalEnabled: false,
        goalMode: "Auto",
        dailyGoal: 0,
        lastGoalUpdate: ""
      },
      chapters: []
    };
    
    setProjects(prevProjects => {
      const updated = [...prevProjects, NewProject];
        const index = updated.length - 1; 
        navigate(`/offline/project/${index}`);
       return updated;
    });

}

return (
    <div className="projectlist-wrapper">
      <ProjectHeader
          headerTitle={"Stwórz projekt"}
          showBackButton={true}
          path={`/local`}
      /> 
       <div className="SettingsForm" style={{marginTop: '100px'}}>
        <form onSubmit={CreateProject}>
                <label>
                  Tytuł projektu
                  <input type="text" name="title" required className="chapterInput" />
                </label>

                <label>
                  Opis
                  <textarea name="description" className="chapterInput" />
                </label>

                <label>
                  Liczba słów
                  <input type="number" name="words" required className="chapterInput"/>
                </label>

                <label>
                  Kiedy chcesz skończyć
                  <input type="date" 
                  {...register("finishDate")} className="chapterInput"/>

                  {errors.finishDate && (
                      <p className="error">{errors.finishDate.message}</p>
                  )}
                </label>

                <label>
                  Okładka
                  <input type="file" accept="image/*" name="cover" className="chapterInput" />
                </label>

                <button className="primary-btn">Utwórz projekt</button>
        </form>

       </div>

       <Link to={`/local`} className="BackfixButton"><IoIosArrowBack /></Link>
        <Flower
          flowerClass={"flower1"}/>
        <Flower
          flowerClass={"flower2"}/>
        <ClickFlower/>
    </div>
) }